<template>
  <div class="section">
    <div class="columns">
      <div class="column is-8-tablet is-offset-2-tablet">
        <div class="block">
          <h4 class="title is-3">Neues Produkt</h4>
        </div>
        <ProductSimple
          :product="product"
          @submit="createProduct"
        ></ProductSimple>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

import ProductSimple from '@/components/editProduct/ProductSimple.vue';

export default {
  name: 'NewProduct',
  components: {
    ProductSimple,
  },
  data() {
    return {
      product: {
        name: '',
        icon: '',
        description: '',
        comment: '',
      },
    };
  },
  computed: {
    ...mapGetters({
      error: 'product/error',
    }),
  },
  methods: {
    createProduct(payload) {
      this.$store.dispatch('product/CREATE', payload);
    },
  },
};
</script>

<style>
</style>
